<!-- begin:: Page -->

<section class="login-bg">
  <div class="row justify-content-center">
    <div class="col-md-12 col-lg-12">
      <div class="wrap d-md-flex">
        <div class="login-wrap">
          <div class="login-cont">
            <div class="d-flex">
              <div class="w-100">
                <h3>
                  <sup></sup> <strong>{{'MasterPageComponent.Labels.PortalName' | translate }} </strong>
                </h3>
              </div>
            </div>

            <div class="white-background">
              <form [formGroup]="loginForm" class="signin-form">
                <div>
                  <div class="form-group mb-3">
                    <label for="username">Username</label>

                    <input type="text" class="form-control form-control-lg" id="userName" name="userName" autocomplete="off"
                           placeholder="Username" formControlName="username" />
                    <div Class="invalid-feedback">This field is required</div>
                  </div>
                  <div class="form-group mb-3">
                    <label for="password">Password</label>
                    <input type="password" class="form-control form-control-lg" id="password" name="password" autocomplete="off"
                           placeholder="Password" formControlName="password" required />
                  </div>
                  <div class="form-group mb-3" *ngIf="false">
                    <label for="username">Insurance Company</label>
                    <select class="form-control form-control-md" id="insuranceCompany" formControlName="insuranceCompany" name="name"
                            placeholder="Select Insurance Company">
                      <option *ngFor="let c of insuranceCompanyList" [value]="c.id">{{ c.name }}</option>
                      <!--styleClass='form-control form-control-sm required' placeholder="{{'LabTestComponent.Labels.SelectCategory' | translate}}"
                      class="required" formControlName="category"-->
                    </select>
                  </div>

                  <div class="form-group">
                    <button class="form-control btn btn-primary rounded submit px-3" [disabled]="!loginForm.valid" (click)="SignIn()">Sign In</button>
                  </div>
                  <div class="form-group" *ngIf="false">
                    <button class="form-control btn btn-primary rounded submit px-3" [disabled]="!loginForm.valid" (click)="ConfirmLogin()">Login</button>
                  </div>
                </div>

              </form>
            </div>
            <div class="copy-write">Copyright<sup>&copy;</sup> 2000-{{currentYear}} ESKADENIA Software.</div>
          </div>
        </div>
        <div class="img-right" style="background-image: url(./assets/images/photo.jpg);">
          <h3>
            <strong>{{'MasterPageComponent.Labels.Referral' | translate }}</strong><span>&nbsp;</span> <strong style="color: #faa74a;">{{'MasterPageComponent.Labels.Portal' | translate }}</strong> {{'MasterPageComponent.Labels.DescriptionLoginPage' | translate }}
          </h3>
          <ul class="d-none">
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<p-dialog class="prime-form-control" [appendTo]="'body'" header="{{'MasterPageComponent.Labels.ChangePassword' | translate }}"
          [style]="{width: '50%',left:'15px'}" [responsive]="true" [(visible)]="showChangePassword" [modal]="true" [draggable]="false">
  <div class="col-12">
    <div class="row">
      <div class="form-group form-group-sm col-md-12">
        <label>Username</label>
        <input type="text" [(ngModel)]="userName" disabled class="form-control" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>Old Password</label>
        <!--<p-password [(ngModel)]="oldPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="oldPassword" class="form-control required" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>
          New Password
          <span *ngIf="checkMatchPassword" class="password-warrning">*</span>
        </label>
        <!--<p-password [(ngModel)]="newPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="newPassword" (input)="CheckMatchPassword(1)" class="form-control required" />
      </div>
      <div class="form-group form-group-sm col-md-4">
        <label>
          Confirm Password
          <span *ngIf="checkMatchPassword" class="password-warrning">*</span>
        </label>
        <!--<p-password [(ngModel)]="confirmPassword" [toggleMask]="true"></p-password>-->
        <input type="password" [(ngModel)]="confirmPassword" (input)="CheckMatchPassword(2)" class="form-control required" />
      </div>

      <div class="form-group form-group-sm col-md-12">
        <div class="kt-form__actions kt-form__actions--right">
          <button class="btn btn-sm btn-brand" [disabled]="!IsValidChangePassword()" (click)="ChangePassword()">Update</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<!--<p-confirmDialog key="positionDialog" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}">
</p-confirmDialog>-->













